
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ScheduleSection from './components/ScheduleSection';

export default function Schedule() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ScheduleSection />
      </main>
      <Footer />
    </div>
  );
}
